import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import UtilityBar from "./sections/UtilityBar";
import TurnYourSmartphoneIntoAMoneyMakingMachine from "./sections/TurnYourSmartphoneIntoAMoneyMakingMachine";
import TheRealityOfOwnership from "./sections/TheRealityOfOwnership";
import TheBimbolaAdvantage from "./sections/TheBimbolaAdvantage";
import ThePathToFinancialClarity from "./sections/ThePathToFinancialClarity";
import RestoringYourPeaceOfMind from "./sections/RestoringYourPeaceOfMind";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <UtilityBar />
      <Header />
      <TurnYourSmartphoneIntoAMoneyMakingMachine />
      <TheRealityOfOwnership />
      <TheBimbolaAdvantage />
      <ThePathToFinancialClarity />
      <RestoringYourPeaceOfMind />
      <Footer />
    </div>;
}